import React from 'react';

const IconCloseSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M1.7998 1.79996L10.1999 10.2" stroke="#111" strokeWidth="1.5" />
    <path d="M10.2002 1.79996L1.80015 10.2" stroke="#111" strokeWidth="1.5" />
  </svg>
);

export default IconCloseSmall;
